<template>
  <div class="select-common">
    <div class="body-wrapper">
      <div class="scroll-wrapper" key="common-scroll-wrapper" v-ps>
        <el-checkbox-group :value="selected">
          <el-checkbox
            v-for="o in options"
            :key="o.id"
            :label="o.id"
            @change="change($event, [o.id])"
          >
            {{ o.name }}
          </el-checkbox>
        </el-checkbox-group>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SelectCommon",
  props: {
    selected: {
      type: Array,
      default: () => []
    },
    options: {
      type: Array,
      default: () => [] // {id:'',name:''}
    }
  },
  data() {
    return {}
  },
  methods: {
    change(isAdd, ids) {
      this.$emit("change", { isAdd, ids })
    }
  }
}
</script>

<style lang="scss" scoped>
.select-common {
  .body-wrapper {
    padding: 6px 6px 6px 12px;
    .breadcrumb {
      display: flex;
      overflow: hidden;
      .breadcrumb-item {
        display: flex;
        flex: 0 0 auto;
        .text {
          color: #407fff;
          cursor: pointer;
          &:hover {
            text-decoration: underline;
          }
        }
        &:last-of-type {
          .text {
            color: unset;
            cursor: unset;
            &:hover {
              text-decoration: unset;
            }
          }
        }
      }
    }
  }
  .scroll-wrapper {
    max-height: 200px;
    min-height: 50px;
    position: relative;
    .el-checkbox-group {
      display: flex;
      flex-flow: column;
      /*自定义文字显示*/
      .checkbox-wrapper {
        display: flex;
        position: relative;
        align-items: center;
        height: 40px;
        .name-wrapper {
          height: 100%;
          flex: 1;
          font-size: 14px;
          display: flex;
          align-items: center;
        }
        .el-icon-arrow-right {
          font-size: 14px;
          position: absolute;
          right: 0px;
          top: 12px;
        }
        &:hover {
          background-color: #f0f4fd;
        }
      }
      .el-checkbox {
        display: flex;
        align-items: center;
        margin-right: 0;
        height: 40px;
        &:hover {
          background-color: #f0f4fd;
        }
        ::v-deep .el-checkbox__label {
          display: flex;
          align-items: center;
          .avatar {
            margin-right: 6px;
          }
        }
      }
    }
  }
}
</style>
